import { useEffect, useRef } from "react";

/**
 * Debounce an effect without re-arming the timer on every render.
 * The callback is kept in a ref so an unstable inline function does not
 * retrigger the effect (which caused update-depth loops under React 19).
 */
const useDebouncedEffect = (func: () => void, deps: any[], delay = 300) => {
  const callbackRef = useRef(func);
  callbackRef.current = func;

  useEffect(() => {
    const handler = setTimeout(() => {
      callbackRef.current();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, delay]);
};

export default useDebouncedEffect;
